// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getLoyaltyTierBenefits } from '@tcp/core/src/services/abstractors/SFCC/getLoyaltyTierBenefits';
import { getIsGuest } from '@tcp/core/src/components/features/account/User/container/User.selectors.js';
import { isCanada } from '@tcp/core/src/utils';
import { validateReduxCache } from '@tcp/core/src/utils/cache.util';
import Abstractor from '@tcp/core/src/services/abstractors/common/loyaltyTierBenefit';
import { getModuleX } from '@tcp/core/src/services/abstractors/common/moduleX';
import ProductAbstractor from '@tcp/core/src/services/abstractors/productListing';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import {
  getIsNonInvSessionFlag,
  getIsLoyaltyBrandThemeEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import ProductsOperator from '@tcp/core/src/components/features/browse/ProductListing/container/productsRequestFormatter';
import LOYALTY_PLACE_REWARDS_CONSTANTS from '../LoyaltyPlaceRewards.constants';
import {
  setLoyaltyTierBenefits,
  fetchLoyaltyBenefitJsonSuccess,
  fetchBrandLoyaltyBenefitJsonSuccess,
  fetchLoyaltyBenefitJsonFailure,
  setModuleXContent,
  setEarlyAccessProducts,
} from './PlaceRewards.actions';
import { getLoyaltyTierBenefitJson } from './PlaceRewards.selectors';

const REFRESH_THRESHOLD = 1 * 60 * 1000; // 1 minute in milliseconds
const instanceProductListing = new ProductAbstractor();
const operatorInstance = new ProductsOperator();

export function* getTierBenefits({ payload }) {
  const guestUser = yield select(getIsGuest);
  const loyaltyTierBenefitsRes =
    !guestUser && !isCanada() ? yield call(getLoyaltyTierBenefits, payload) : [];
  yield put(setLoyaltyTierBenefits(loyaltyTierBenefitsRes?.benefits));
}

export function* fetchLoyaltyTierBenefitJsonSaga() {
  try {
    const existingBenefitData = yield select(getLoyaltyTierBenefitJson);
    const currentTime = new Date().getTime();

    if (
      existingBenefitData?.data?.length &&
      existingBenefitData?.timestamp &&
      currentTime - existingBenefitData.timestamp < REFRESH_THRESHOLD
    ) {
      return;
    }

    const isBrandThemeEnabled = yield select(getIsLoyaltyBrandThemeEnabled);

    if (isBrandThemeEnabled) {
      const newBrandBenefitsData = yield call(
        Abstractor.getLoyaltyTierBenefitData,
        'tier_benefits_new'
      );
      yield put(fetchBrandLoyaltyBenefitJsonSuccess(newBrandBenefitsData));
    }
    const newBenefitsData = yield call(Abstractor.getLoyaltyTierBenefitData, 'tier_benefits');

    yield put(fetchLoyaltyBenefitJsonSuccess(newBenefitsData));
  } catch (error) {
    logger.error('Error fetching Loyalty Benefit Json:', error);
    yield put(fetchLoyaltyBenefitJsonFailure(error));
  }
}

export function* fetchModuleX({ payload = '' }) {
  try {
    if (payload) {
      const result = yield call(getModuleX, payload);
      yield put(setModuleXContent(result.richText));
    }
  } catch (error) {
    logger.error('Error fetching ModuleX data:', error);
    yield null;
  }
}

export function* fetchEaProducts() {
  try {
    const state = yield select();

    const reqObj = operatorInstance.getProductsListingFilters({
      state,
      pageNumber: 1,
      location: window.location,
    });

    reqObj.isFromMPRPage = true;
    reqObj.isSearch = true;
    reqObj.numberOfProducts = 50;
    reqObj.seoKeywordOrCategoryIdOrSearchTerm = '*';

    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const isNonInvABTestEnabled = yield select(getIsNonInvSessionFlag);

    const res = yield call(
      instanceProductListing.getProducts,
      reqObj,
      state,
      null,
      null,
      xappURLConfig,
      isNonInvABTestEnabled,
      false
    );

    if (res && res.loadedProductsPages && res.loadedProductsPages.length > 0) {
      yield put(setEarlyAccessProducts(res.loadedProductsPages[0]));
    } else {
      throw new Error('Search Products API did not return data');
    }
  } catch (error) {
    // Handle errors appropriately
    logger.error('fetchEaProducts saga error:', error);
  }
}

export function* LoyaltyPlaceRewardsSaga() {
  const cachedModuleX = validateReduxCache(fetchModuleX);
  yield takeLatest(LOYALTY_PLACE_REWARDS_CONSTANTS.GET_MODULE_X_CONTENT, cachedModuleX);
  yield takeLatest(LOYALTY_PLACE_REWARDS_CONSTANTS?.GET_TIER_BENEFITS, getTierBenefits);
  yield takeLatest(
    LOYALTY_PLACE_REWARDS_CONSTANTS?.FETCH_LOYALTY_BENEFIT_JSON_REQUEST,
    fetchLoyaltyTierBenefitJsonSaga
  );
  yield takeLatest(LOYALTY_PLACE_REWARDS_CONSTANTS.FETCH_EA_PRODUCTS, fetchEaProducts);
}

export default LoyaltyPlaceRewardsSaga;
